import React, { useCallback, useContext, useEffect, useState } from "react";
import { Col, Row, Card } from "@themesberg/react-bootstrap";
import { Context } from "../SalesTicketStorage";
import { getSummaryClassicSalesTicket } from "../../../../controller/api/__classic__/ticketStorage";
import { useCookies } from "react-cookie";

const _Summary = ({ region }) => {
  const { state } = useContext(Context);
  const [cookies] = useCookies(["lottmekong"]);

  const [summary, setSummary] = useState({
    total: 0,
    data: [],
  });

  const getSummaryFunc = useCallback(async () => {
    const response = await getSummaryClassicSalesTicket(cookies.lottmekong, {
      region: region,
      channel: state.channel,
      fromDate: state.fromDate,
      toDate: state.toDate,
      numbers: state.numbers,
    });

    if (response) {
      setSummary({
        total: response.total,
        data: response.data || [],
      });
    }
  }, [
    cookies.lottmekong,
    region,
    state.channel,
    state.fromDate,
    state.toDate,
    state.numbers,
  ]);

  useEffect(() => {
    getSummaryFunc();
  }, [getSummaryFunc, state.filterPressCount]);

  const StatCard = ({ title, value, variant = "primary" }) => (
    <Card
      border="light"
      className={`shadow-sm h-100 border-0 border-start border-4 border-${variant}`}
      style={{ transition: "transform 0.2s" }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-3px)";
        e.currentTarget.className = e.currentTarget.className.replace(
          "shadow-sm",
          "shadow",
        );
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.className = e.currentTarget.className.replace(
          "shadow",
          "shadow-sm",
        );
      }}
    >
      <Card.Body className="py-3 px-4">
        <div className="text-muted small fw-bold text-uppercase mb-1">
          {title}
        </div>
        <h3 className={`fw-bold text-${variant} mb-0`}>
          {new Intl.NumberFormat("vi-VN").format(value)}
        </h3>
      </Card.Body>
    </Card>
  );

  // Map the data from API response to the display format
  const getStatValue = (key) => {
    const item = summary.data.find((d) => d.key === key);
    return item ? item.sum : 0;
  };

  return (
    <Row className="mb-4 g-3">
      <Col md={3} sm={6} xs={6}>
        <StatCard
          title="Tổng vé nhập"
          value={getStatValue("input")}
          variant="primary"
        />
      </Col>
      <Col md={3} sm={6} xs={6}>
        <StatCard
          title="Tổng vé bán"
          value={getStatValue("sold")}
          variant="success"
        />
      </Col>
      <Col md={3} sm={6} xs={6}>
        <StatCard
          title="Tổng vé hoàn trả"
          value={getStatValue("returned")}
          variant="danger"
        />
      </Col>
      <Col md={3} sm={6} xs={6}>
        <StatCard
          title="Tổng vé tồn"
          value={getStatValue("remaining")}
          variant="info"
        />
      </Col>
    </Row>
  );
};

export default React.memo(_Summary);
